"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var material_1 = require("@mui/material");

var logo_none_svg_1 = __importDefault(require("../../images/logo-none.svg"));

var logo_right_svg_1 = __importDefault(require("../../images/logo-right.svg"));

var logo_bottom_svg_1 = __importDefault(require("../../images/logo-bottom.svg"));

var Logo = function (props) {
  var anchor = props.anchor;

  var defaultProps = __assign({}, props);

  var renderParameter = function (anchor) {
    switch (anchor) {
      case "right":
        return logo_right_svg_1["default"];

      case "bottom":
        return logo_bottom_svg_1["default"];

      default:
        return logo_none_svg_1["default"];
    }
  };

  return react_1["default"].createElement(material_1.Container, {
    component: "div"
  }, react_1["default"].createElement("img", __assign({}, defaultProps, {
    src: renderParameter(anchor),
    alt: "logo-aa-".concat(anchor)
  })));
};

exports["default"] = Logo;